// @ts-nocheck

const dataLayer = window.dataLayer || []

export default dataLayer
